<template>
    <div id="pj_wrap">
        <comheader></comheader>
        <div class="lf ks_right" id="rmodel">
        <comtop></comtop>
        <h2>权限管理<b>></b></h2>
        <div class="pj_cread">
          <ul>
            <li><img src="/static/img/bm.png">
            <router-link :to="{name:'bmgl'}">
                   部门/人员管理列表               
            </router-link>  
            </li>
            <li class="pjcread_on" ><img src="/static/img/gl.png">
            <router-link :to="{name:'manager',query: {view:'js'}}">
                   管理员/角色权限               
            </router-link>  </li>
          </ul>
        </div>
        <div class="zt_title" v-if="userquery=='js'">
            <span >
                <router-link :to="{name:'manager',query: {view:'js'}}">
                    角色管理                  
                </router-link>              
            </span> 
            <em></em>
            <span  class="zt_on">
                <router-link :to="{name:'manager',query: {view:'gl'}}">
                    管理员管理                  
                </router-link>           
            </span>
            <div class="zt_cread rf" @click="showb(0)"  @add="adduser">
                <i class="el-icon-plus"></i>
                <span>添加角色</span>
            </div>
        </div>
        <div class="zt_title" v-else>
            <span class="zt_on" >
                <router-link :to="{name:'manager',query: {view:'js'}}">
                    角色管理                  
                </router-link>              
            </span> 
            <em></em>
            <span>
                <router-link :to="{name:'manager',query: {view:'gl'}}">
                    管理员管理                  
                </router-link>           
            </span>
            <div class="zt_cread rf" @click="showb(1)">
                <i class="el-icon-plus"></i>
                <span>添加管理员</span>
          </div>
        </div>
      <div class="clear"></div>
      <div class="js_list" v-if="userquery=='js'">
        <ul>
            <li v-for="(item,index) in listuser" :key="index" :data-id="item.part_id">
                <div class="js_name lf">
                    <img src='/static/img/hgl.png' >
                    <span>{{item.part_name}}</span>
                </div>
                <div class="js_cz rf">
                    <button class="js_on" @click="showb(3,item.part_id,index,'',item.part_name)" @editname="edituser">编辑</button>
                    <button @click="showb(2,index,item.part_id,1)"><img src="/static/img/del.png" >删除</button>
                </div>
            </li>
        </ul>
        <page :count="jscount" :Page.sync='jspage' @pagenation='jspagetion'></page>
      </div>
      <div class="js_list" v-else>
        <ul>
            <li v-for="(item,index) in listpeo.info" :key="index" :data-id="item.user_id">
                <div class="js_name lf">
                    <img :src='item.head_pic' onerror="javascript:this.src='/static/img/sex0.jpg';">
                    <span>{{item.nickname}}</span>
                </div>
                <div class="js_cz rf">
                    <button class="js_on"  @click="showb(4,item.admin_id,index,'',item.nickname)" @editname="edituser">编辑</button>
                    <button @click="showb(2,index,item.admin_id,2)"><img src="/static/img/del.png" >删除</button>
                </div>
            </li>
        </ul>
        <page :count="count" :Page.sync='page' @pagenation='pagetion'></page>
      </div>
      </div>
          <tc
        :show.sync="show" 
        :modelpeo.sync='modeloa'
        :modelde.sync="modeldel" 
        :medit.sync="edit"
        :username='username'
        :part='part'
        :jsname.sync='jsname'
        @add="adduser"
        @editname="edituser"
        :nrtitle="nrtitle"
        :listedit="listedit"
        :listadmin="listadmin"
        :listcheckid.sync="checkid"
        :partid.sync="partid"
        :id='id'  
        :dataid='dataid' 
        @delt="dellist" 
        :modeuser.sync='modeluser'
        :title="title"></tc>
    </div>
</template>

<script>

import comheader from '../Common/comheader'
import comtop from '../Common/comtop'
import tc from './tc.vue'
import page from '../Common/page'
export default {
  name: 'manager',
  inject:["reload"],
  data(){
      return{
        listpeo:[],
        jscount:0,
        listuser:[],
        listedit:[],
        listimg:[],
        listadmin:'', 
        checkid:[],
        modeldel:false,
        username:'',
        modeloa:false,
        part:'',
        modeluser:false,
        edit:false,
        show: false,
        title:'',
        id:'',
        temp:true,
        jspage:1,
        len:'',
        eid:'',
        nrtitle:'',
        jsname:'',
        dataid:'',
        delid:'',
        partid:'',
        limit:10, //一页几条数据
        count:0, //数据总计
        page:1, //当前页数
        userquery:this.$route.query.view,
      }
  }, 
  components:{
    comheader,
    page,
    comtop,
    tc
  },
  methods:{  
    showb(d,id,dataid,key,name){
      if(d==1){
        this.modeloa=true
        this.title='快速查找人员'
      }
      else if(d==0){
        this.modeluser=true
        this.title='添加角色'
        this.username=''
        var len =$('.js_list').eq(0).find('li').length;
        this.len=len
      }
      else if(d==2){
          this.modeldel=true      
          this.title="删除"    
          this.nrtitle="此操作将永久删除，是否继续" 
          this.dataid=dataid
          this.id=id
          this.delid=key
      }
      else if(d==3){
          this.checkid=[]
          let str=this.checkid
          this.edit=true;
          this.title="编辑角色"
          this.jsname=name
          this.part=1
          this.eid=id
          this.dataid=dataid
          var data = {
            'service':'Admin.Part_Edit',
            'userid':localStorage.getItem('userid'),
            'part_id':this.eid
          } 
          this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res=>{
                if(res.data.data.info.auth.length!==0){
                  var arr = res.data.data.info.auth.split(",")
                  this.listedit =arr
                }
                else{
                  this.listedit =[]
                }
            })
            .catch(function (error) { // 请求失败处理
        });
      }
        else if(d==4){
          this.checkid=[]
          let str=this.checkid
          this.edit=true;
          this.title="编辑管理员权限"
          this.part=2
          this.jsname=name
          this.eid=id
          this.dataid=dataid
          var data = {
            service:'Admin.Admin_Data',
            admin_id:id
          }
          this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res=>{
              this.listadmin=res.data.data.info.part_id
            })
            .catch(function (error) { // 请求失败处理
        });
      }
      this.show=true
      
    },
    tempTab(t){
      this.temp=t
    },
    dellist(index,dataid){
      if(this.delid==1){
        var data={
          'service':'Admin.AdminRole_Delete',
          part_id:dataid,
          userid:localStorage.getItem('userid')
        }
        this.$axios.post(this.HOME,this.$qs.stringify(data))
          .then(res => {
            if(res.data.data.code!==0){
              this.alertView.failView(res.data.data.msg)
              return false
            }

              this.listuser.splice(index,1)
              this.alertView.successView('删除成功')
                 this.reload();
            }
          )
          .catch(function (error) { // 请求失败处理
          });
      }
      else{
        var deldata={
          'service':'Admin.Admin_Del',
          'userid':localStorage.getItem('userid'),
          'admin_id':dataid
        }
        this.$axios.post(this.HOME,this.$qs.stringify(deldata))
          .then(res => {
              if(res.data.data.code==0){
                this.alertView.successView('删除管理员成功')
                this.reload()
                return false
              }
                this.alertView.failView(res.data.data.msg)
            }
          )
          .catch(function (error) { // 请求失败处理
          });
      }    
    },
    edituser(name,checkid,id){
        if(this.part==1){
        // let data ={_method:'PUT','id':this.eid,'name':name,'auth':this.checkid.join()}
        // console.log(this.checkid.join())
        // let user_name={'part_name':name}
        //  this.$axios.post('http://pf.junchenlun.com/api/v1/edit_part',this.$qs.stringify(data))
        //   .then(res => {
        //     if(res.data.code==0){
        //       alert(res.data.meg)
        //      this.reload();
        //      console.log(data)
        //     }
        //     else{
        //        this.listuser.splice(this.dataid,1,user_name)
        //        this.reload();
        //     }
        //     }
        //   )
        //   .catch(function (error) { // 请求失败处理
        //   });
         var data={'service':'Admin.AdminRole_Update','auth_id':checkid,'userid':localStorage.getItem('userid'),'part_name':name,'part_id':this.eid}
        this.$axios.post(this.HOME,this.$qs.stringify(data))
          .then(res => {
            if(res.data.data.code==0){
              this.alertView.successView(res.data.data.msg)
              this.reload();
            }
            else{
              this.alertView.failView(res.data.data.msg)
              this.listuser.splice(this.len,0,user_name)
              this.reload();
            }
          })
          .catch(function (error) { // 请求失败处理
          });
          }
          else{
              let data ={service:'Admin.Admin_Edit',userid:localStorage.getItem('userid'),'admin_id':this.eid,'part_id':checkid}
              this.$axios.post(this.HOME,this.$qs.stringify(data))
                .then(res => {
                  if(res.data.data.code==0){
                    this.alertView.successView(res.data.data.msg)
                    this.reload();
                  }
                  else{
                    this.alertView.failView(res.data.data.msg)
                    this.reload();
                  }
                })
              }
    },                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
    adduser(name,auth){
        var data={'service':'Admin.Add_AdminRole','part_name':name,'auth_id':auth,'userid':localStorage.getItem('userid')}
        this.$axios.post(this.HOME,this.$qs.stringify(data))
          .then(res => {
            if(res.data.data.code==0){
              this.alertView.successView(res.data.data.msg)
              this.reload();
            }
            else{
              this.alertView.failView(res.data.data.msg)
              this.listuser.splice(this.len,0,user_name)
              this.reload();
            }
          })
          .catch(function (error) { // 请求失败处理
          });
    },
    jspagetion(limit,page){
          var data ={
            service:'Admin.Adminrole',
            page:page,
            limit:limit
          }
            this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res => {
              this.listuser = res.data.data.info
            })
            .catch(function (error) { // 请求失败处理
            });
      },
     pagetion(limit,page){
        var dataup={
          service:'Admin.Adminlist',limit:limit,page:page
        }
       this.$axios.post(this.HOME,this.$qs.stringify(dataup))
      .then(res => {
        console.log(res)
        this.listpeo = res.data.data
        this.count =parseInt(res.data.data.count)
      })
      .catch(function (error) { // 请求失败处理
      });
         
      }
  },
  watch:{
  $route(to,from){
   this.reload()
  }
},
  mounted(){
    var data ={
      service:'Admin.Adminrole'
    }
      var dataup={
          service:'Admin.Adminlist'
        }
       this.$axios.post(this.HOME,this.$qs.stringify(dataup))
      .then(res => {
        console.log(res)
        this.listpeo = res.data.data
        this.count =parseInt(res.data.data.count)
      })
      .catch(function (error) { // 请求失败处理
      });
     this.$axios.post(this.HOME,this.$qs.stringify(data))
      .then(res => {
        this.listuser = res.data.data.info
        this.jscount =parseInt(res.data.data.count)
      })
      .catch(function (error) { // 请求失败处理
      });

  }

}
</script>
<style>
@import "../../assets/css/manager.css";
</style>
 <style>
  .js_list .number{height: 28px;}
 </style>


// WEBPACK FOOTER //
// src/components/manager/manager.vue